export default __webpack_public_path__ + "static/media/c001-student-5.0e2bf55e.jpg";